"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollMonthExpenseProvider = void 0;
var PayrollMonthExpenseProvider;
(function (PayrollMonthExpenseProvider) {
    PayrollMonthExpenseProvider["SELF_REPORTED"] = "SELF_REPORTED";
})(PayrollMonthExpenseProvider || (exports.PayrollMonthExpenseProvider = PayrollMonthExpenseProvider = {}));
